import { render, staticRenderFns } from "./fiveAdvantages.vue?vue&type=template&id=7debdc9a&scoped=true&"
import script from "./fiveAdvantages.vue?vue&type=script&lang=js&"
export * from "./fiveAdvantages.vue?vue&type=script&lang=js&"
import style0 from "./fiveAdvantages.vue?vue&type=style&index=0&id=7debdc9a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7debdc9a",
  null
  
)

export default component.exports